module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-ruled-b9c21878.svg";